import {
    useApplyConfirmationDelete,
    useCancelConfirmationDelete,
    useDeleteConfirmationGoodId
} from '@entities/basket/hooks'
import React from 'react'
import ModalWindow from '@shared/ModalWindow/ModalWindow'

export const ModalsCatalog = () => {
    const deleteConfirmationGoodId = useDeleteConfirmationGoodId()
    const applyDelete = useApplyConfirmationDelete()
    const cancelDelete = useCancelConfirmationDelete()

    return (
        <React.Fragment>
            {deleteConfirmationGoodId ? (
                <ModalWindow
                    title="Удаление из корзины"
                    submit={{
                        text: 'Удалить',
                        clickHandler: applyDelete
                    }}
                    cancel={{
                        text: 'Отмена',
                        clickHandler: cancelDelete
                    }}>
                    Вы действительно хотите удалить выбранный товар из корзины?
                </ModalWindow>
            ) : (
                <React.Fragment />
            )}
        </React.Fragment>
    )
}
